<template>
  <div class="detailsBg">
    <div class="closeIcon pa iconfont iconcha color_9c" @click.stop="$emit('setNotfindResumeState', false)"></div>

    <div class='notfindResume pa text_center bg_fff'>
      <div class="iconfont iconjinggao color_blue"></div>
      <div class='title f_18 color_40 font_w_b'>简历已失效</div>
      <div class='text f_14 color_60'>招聘求职风雨莫测，龙卷风吹跑了这份简历</div>
      <div class="button bg_current color_fff f_14 cursor_p text_center" @click="$emit('setNotfindResumeState', false)">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notfindResume',
  props:{
    
  },
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/css/components/resumeDetail.scss';
</style>